import React from "react";
import { toogleCheckboxCheckClassName } from "../../helpers/shared";
import { ProductVariants, PropertiesGroup } from "../../models/API";
import { ProductItemProps, VariantProductItemProps } from "./model";

export const VariantFinishingGuide: React.FC<
  VariantProductItemProps & ProductItemProps
> = (props) => {
  const ProductTableData = (propertiesGroupData: PropertiesGroup) => {
    return (
      <React.Fragment>
        <div className="header">{propertiesGroupData.GroupName}</div>
        <div className="dataholder">
          {propertiesGroupData.Properties &&
            propertiesGroupData.Properties.map((property, index) => {
              return (
                property.Value && (
                  <div
                    className="data"
                    key={`ProductTableData-${property.Id}-property-${index}`}
                  >
                    <span>{property.DisplayName}</span>
                    {property.Value} {property.Unit}
                  </div>
                )
              );
            })}
        </div>
      </React.Fragment>
    );
  };

  const ProductVariantRow = (variantData: ProductVariants) => {
    return (
      <div className="row">
        {variantData.VariantUrl ? (
          <div className="name"><a href={variantData.VariantUrl}>{variantData.VariantName}</a></div>
        ) : (<div className="name">{variantData.VariantName}</div>)}
        <div className="content-holder">
          <div className="content">
            {variantData.PropertiesGroups &&
              variantData.PropertiesGroups.map((propertiesGroup, index) => {
                const hideProductTableDataIsEveryValuesIsEmpty =
                  propertiesGroup.Properties &&
                  propertiesGroup.Properties.every(
                    (property) => !property.Value
                  );
                return (
                  !hideProductTableDataIsEveryValuesIsEmpty && (
                    <ProductTableData
                      {...propertiesGroup}
                      key={`ProductVariantRow-${variantData.Id}-propertiesGroup-${index}`}
                    />
                  )
                );
              })}
          </div>
        </div>
        <div className="checkboxes">
          <div className="col checkbox inquiry">
            <span>{props.dictionary.InquiryText}</span>
            <i
              className={toogleCheckboxCheckClassName(
                props.dataForInquiry,
                variantData.Id
              )}
              onClick={() => {
                props.selectForInquiry(variantData.Id);
              }}
            ></i>
          </div>
          <div className="col checkbox compare">
            <span>{props.dictionary.CompareText}</span>
            <i
              className={toogleCheckboxCheckClassName(
                props.compareProductsSelected,
                variantData.Id
              )}
              onClick={() => {
                props.selectForComparison(variantData.Id);
              }}
            ></i>
          </div>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="checkbox-placer">
        <div className="checkboxes">
          <div className="col checkbox inquiry">
            <span>{props.dictionary.InquiryText}</span>
          </div>
          <div className="col checkbox compare">
            <span>{props.dictionary.CompareText}</span>
          </div>
        </div>
      </div>
      <div className="finishing-item-list-holder">
        {props.productData.Variants &&
          props.productData.Variants.map((variant, index) => {
            return (
              <ProductVariantRow
                {...variant}
                key={`ProductVariantRow-${variant.Id}-variant-${index}`}
              />
            );
          })}
      </div>
    </React.Fragment>
  );
};
